<template>
  <div
    class="module module-text-image no-padding"
    v-observe-visibility="visibilityChanged"
    :class="[{ 'show-up': isVisible }, baseAnimation, 'bg-' + data.theme]"
  >
    <ModuleContainer :class="data.direction">
      <WpImage
        :data="data.image"
        size="extra_large"
        insideclass="picture_demension picture_demension--16x9"
        background
        placeholder
        lazy
      />
      <div class="content padding_large">
        <ModuleHeading v-if="data.text_side.title" :level="2">{{
          data.text_side.title
        }}</ModuleHeading>
        <DynamicHtml
          v-if="data.text_side.content"
          :html="data.text_side.content"
        />
        <LinksLine v-if="data.text_side.links" :data="data.text_side.links" />
      </div>
    </ModuleContainer>
  </div>
</template>

<script>
import WpImage from "@/components/elements/WpImage";
import LinksLine from "@/components/blocks/LinksLine";

export default {
  name: "text-image",
  props: ["data"],
  computed: {},
  components: {
    WpImage,
    LinksLine
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";
.module-text-image {
  .module-container {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    @include mquery(767px) {
      flex-direction: column;
    }
    &.left {
      .content {
        order: 1;
      }
      .image-hold {
        order: 0;
      }
    }
    &.right {
      .content {
        order: 0;
        @include mquery(767px) {
          order: 1;
        }
      }
      .image-hold {
        order: 1;
        @include mquery(767px) {
          order: 0;
        }
      }
    }
    .content,
    .image-hold {
      max-width: 50%;
      width: 100%;
      @include mquery(767px) {
        max-width: 100%;
      }
    }
    .image-hold {
      margin: 0;
      .useholder {
        position: relative;
      }
      .picture_demension {
        height: 0;
        display: block;
        &.picture_demension--square,
        &.picture_demension--1x1 {
          padding-bottom: 100%;
        }

        &.picture_demension--4x3 {
          padding-bottom: 75%;
        }
        &.picture_demension--3x4 {
          padding-bottom: 133%;
        }

        &.picture_demension--16x9 {
          padding-bottom: 56.25%;
        }
        figure,
        .lazyloading,
        .bg-image {
          padding-bottom: inherit;
          background-size: cover;
          background-position: center center;
          position: relative;
          z-index: 2;
        }
        &.picture_demension--none {
          padding-bottom: auto;
          height: auto;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 10;
          figcaption {
            display: none;
          }
          figure,
          .lazyloading,
          .bg-image {
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            position: absolute;
            background-size: cover;
            background-position: center center;
          }
        }
      }
    }
    .module-header,
    .html-content {
      margin-bottom: 20px;
    }
  }
}
</style>
